import { AutogenModelOrdersTrailerType, AutogenRowOrdersTrailerType } from "./autogen/AutogenModelOrdersTrailerType";

export class ModelOrdersTrailerType extends AutogenModelOrdersTrailerType<RowOrdersTrailerType> {
    constructor() {
        super(RowOrdersTrailerType);
    }
}

export class RowOrdersTrailerType extends AutogenRowOrdersTrailerType {
}